import { render, staticRenderFns } from "./UtmContentInput.vue?vue&type=template&id=5010e85a&"
import script from "./UtmContentInput.vue?vue&type=script&lang=js&"
export * from "./UtmContentInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports